var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLengthIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 3.019V2h2V1a1 1 0 00-1-1H6a1 1 0 00-1 1v1h2v1.019a6.5 6.5 0 101 0zm3.036 10.017c-.944.944-2.2 1.464-3.536 1.464s-2.591-.52-3.536-1.464C3.02 12.092 2.5 10.836 2.5 9.5s.52-2.591 1.464-3.536a4.967 4.967 0 013.377-1.462l-.339 4.907c-.029.411.195.591.497.591s.527-.18.497-.591l-.339-4.907c1.276.04 2.47.555 3.377 1.462.944.944 1.464 2.2 1.464 3.536s-.52 2.591-1.464 3.536z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLengthIcon);
export default __webpack_public_path__ + "static/media/length-icon.7ffef84ec63a43ce6f7b9691cd929e98.svg";
export { ForwardRef as ReactComponent };